import React from 'react'
import { connect } from 'react-redux'
import './index.scss'
import Filters from './filters'
import { activeLayerIds, visibleLayerIds } from '../../../lib/layerVisibility'

const TopMatter = props => {
  const { activeLayers, layersDictionary } = props
  const hasFilterable = activeLayers.find(id => layersDictionary[id] ? layersDictionary[id].filterOnUnit : null)

  return (
    <div>
      { hasFilterable ? <Filters /> : null }
    </div>
  )
}

const mapStateToProps = state => ({
  // Filtered by the layers eye toggle (WEB-7048): the unit filter bar belongs to a
  // filterable layer, so it goes away with the layer rather than hovering over a map
  // that no longer draws the thing it filters.
  activeLayers: visibleLayerIds({
    activeIds: activeLayerIds(state.userSettings),
    layersDictionary: state.layersDictionary,
    layersVisible: state.layersVisible
  }),
  layersDictionary: state.layersDictionary,
  rightToolbarState: state.rightToolbarState
})

const mapDispatchToProps = state => ({

})

export default connect(mapStateToProps, mapDispatchToProps)(TopMatter)
